export default __webpack_public_path__ + "static/media/1.0caa4016.jpg";